import { DefaultButton } from "../button/defaultButton/DefaultButton";
import styles from "./ErrorPage.module.scss";
import { useNavigate } from "react-router-dom";
import { routePaths } from "../../infrastructure/routes/routePaths";

export const NoStudiosFound = () => {
  const navigate = useNavigate();

  const logout = () => {
    navigate(routePaths.logout);
  };

  return (
    <div className={styles.root}>
      <div>
        <p>Към момента нямате добавени обекти.</p>
        <p className={styles.root_secondary}>
          {" "}
          Моля свържете се с нас, за да добавим такива.
        </p>
      </div>

      <DefaultButton
        className={styles.root_button}
        label={"Изход"}
        onClick={logout}
      />
    </div>
  );
};
